/* eslint-disable array-callback-return */
import * as Yup from "yup";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useMemo, useState } from "react";
import Loader from "../Loader";
import countryList from "react-select-country-list";
import Select from "react-select";
const AddAddress = () => {
  const navigate = useNavigate();
  const [loader, setloader] = useState(false);
  const [value, setValue] = useState("");
  const options = useMemo(() => countryList().getData(), []);
  const changeHandler = (value) => {
    setValue(value);
    formik.setFieldValue("country", value?.label);
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      country: "",
      streetAddress: "",
      apartment: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: "",
      paymentMethod: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is required"),
      paymentMethod: Yup.string().required("Location Type  is required"),
      lastName: Yup.string().required("Last Name is required"),
      country: Yup.string().required("Country is required"),
      streetAddress: Yup.string().required("Street Address is required"),
      city: Yup.string().required("City is required"),
      state: Yup.string().required("State is required"),
      zip: Yup.string().required("Zip is required"),
      phone: Yup.string()
        .required("Phone is required")
        .matches(/^[0-9]+$/, "Phone must be numeric"),
      email: Yup.string()
        .required("Email is required")
        .email("Invalid email address"),
    }),
    onSubmit: async (values, resetForm) => {
      setloader(true);
      try {
        const formData = new FormData();
        formData.append(`first_name`, values?.firstName);
        formData.append(`last_name`, values?.lastName);
        formData.append(`email`, values?.email);
        formData.append(`street_address`, values?.streetAddress);
        formData.append(`address`, values?.streetAddress);
        formData.append(`phone`, values?.phone);
        formData.append(`country`, values?.country);
        formData.append(`apartment_suit`, values?.apartment);
        formData.append(`state`, values?.state);
        formData.append(`city`, values?.city);
        formData.append(`zip`, values?.zip);
        formData.append(`type`, values?.paymentMethod);

        const response = await axiosInstance.post(
          "user/addressmanagement",
          formData
        );

        if (response.data.status === true) {
          setloader(false);

          toast.success(
            response?.data?.message || "A New Address Has Been Added"
          );
          navigate("/saveaddress");
          resetForm();
        }
      } catch (error) {
        setloader(false);

        const { message } = error?.response?.data;
        toast.error(message);
      }
    },
  });

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="container">
          <div className="row">
            <div className="wow fadeInUp" data-wow-duration="1s">
              <div className="checkout_form">
                <div className="check_form">
                  <div className="row mt_30">
                    <div className="col-12">
                      <h5>Billing Address</h5>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={formik.values.firstName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.firstName && (
                          <div className="text-red py-2">
                            {formik.errors.firstName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={formik.values.lastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.lastName && formik.errors.lastName && (
                          <div className="text-red py-2">
                            {formik.errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="reservation_input_single">
                        {/* <select
                          name="country"
                          value={formik.values.country}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{
                            width: "100%",
                            padding: "12px 20px",
                            outline: "none",
                            resize: "none",
                            border: "1px solid #eee",
                            borderRadius: "4px",
                            fontSize: "16px",
                            fontWeight: "300",
                          }}
                        >
                          <option value="">Select Country</option>
                          <option value="bangladesh">Bangladesh</option>
                          <option value="nepal">Nepal</option>
                          <option value="japan">Japan</option>
                          <option value="korea">Korea</option>
                          <option value="thailand">Thailand</option>
                        </select> */}
                        <Select
                          options={options}
                          value={value}
                          onChange={changeHandler}
                        />
                        {formik.touched.country && formik.errors.country && (
                          <div className="text-red py-2">
                            {formik.errors.country}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="streetAddress"
                          placeholder="Street Address *"
                          value={formik.values.streetAddress}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.streetAddress &&
                          formik.errors.streetAddress && (
                            <div className="text-red py-2">
                              {formik.errors.streetAddress}
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="apartment"
                          placeholder="Apartment, suite, unit, etc. (optional)"
                          value={formik.values.apartment}
                          onChange={formik.handleChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="city"
                          placeholder="Town / City *"
                          value={formik.values.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.city && formik.errors.city && (
                          <div className="text-red py-2">
                            {formik.errors.city}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="state"
                          placeholder="State *"
                          value={formik.values.state}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.state && formik.errors.state && (
                          <div className="text-red py-2">
                            {formik.errors.state}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="zip"
                          placeholder="Zip *"
                          value={formik.values.zip}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.zip && formik.errors.zip && (
                          <div className="text-red py-2">
                            {formik.errors.zip}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Phone *"
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.phone && formik.errors.phone && (
                          <div className="text-red py-2">
                            {formik.errors.phone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-12 col-xl-6">
                      <div className="check_single_form">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email *"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.email && formik.errors.email && (
                          <div className="text-red py-2">
                            {formik.errors.email}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-6 col-12">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="p-2 form-check-input"
                          type="radio"
                          name="paymentMethod"
                          value="home"
                          onChange={formik.handleChange}
                          checked={formik.values.paymentMethod === "home"}
                        />
                        <label className="form-check-label" htmlFor="home">
                          Home
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-6 col-xl-6">
                      <div className="d-flex align-items-center gap-2">
                        <input
                          className="p-2 form-check-input"
                          type="radio"
                          name="paymentMethod"
                          value="office"
                          onChange={formik.handleChange}
                          checked={formik.values.paymentMethod === "office"}
                        />
                        <label className="form-check-label" htmlFor="office">
                          Office
                        </label>
                      </div>
                    </div>

                    {formik.errors.paymentMethod && (
                      <div className="text-red py-2 col-12">
                        {formik.errors.paymentMethod}
                      </div>
                    )}

                    <div className="col-md-12 my-4">
                      <button
                        onClick={formik.handleSubmit}
                        className="common_btn"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddAddress;
